module.exports = __webpack_public_path__ + "img/business2.1e5a60b3.png";